import { getProductInventoryPairs } from '@libs/api-proxy-client';
import type { Inventory } from '@libs/common-node';

export type FetchInventoryList = {
    sku: string;
    store: string;
}[];

export const fetchInventoryList = async (skuStorePair: FetchInventoryList): Promise<Inventory[]> => {
    return await getProductInventoryPairs(skuStorePair, { throwOnError: true });
};
